<div [formGroup]="formParent">
    <p-dropdown [appendTo]=AppendMydiv
                [options]="list"  
                [disabled]="isEditing" 
                [formControlName]="selected" 
                [optionLabel]="filter"
                optionValue="id" 
                [filter]="true" 
                [filterBy]="filter" 
                [showClear]="true"
                [placeholder]="'Seleccione '+ph"
                (onChange)="onChangeCombo($event)">
        
        <ng-template let-sel pTemplate="selectedItem">
            <div class="personal-item personal-item-value">
                <div *ngIf="!soloCodigo && !soloDescri">{{sel.code}}{{sel.codigo}}{{sel.idgrupo}} - {{sel[filter]}}</div>
                <div *ngIf="soloCodigo && !soloDescri">{{sel.code}}{{sel.codigo}}{{sel.idgrupo}}</div>
                <div *ngIf="soloDescri">{{sel[filter]}}</div>
            </div>
        </ng-template>
        <ng-template let-list pTemplate="item">
            <div class="list-item">
                <div *ngIf="!soloCodigo && !soloDescri">{{list.code}}{{list.codigo}}{{list.idgrupo}} - {{list[filter]}}</div>
                <div *ngIf="soloCodigo && !soloDescri">{{list.code}}{{list.codigo}}{{list.idgrupo}}</div>
                <div *ngIf="soloDescri">{{list[filter]}}</div>
            </div>
        </ng-template>
    </p-dropdown>
</div>